import React, { useEffect, useState } from 'react';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';
import { get } from 'lodash';

import { refreshReloadPrompt } from 'hooks';
import PageTemplate from 'components/general/PageTemplate';
import { getOrganizations } from 'api/organization';
import OrganizationModal from './OrganizationModal';
import {
  columns,
  suggestionPrimaryKey,
  suggestionSecondaryKeys,
} from './organization.config';

const Services = () => {
  const { path } = useRouteMatch();
  const history = useHistory();

  const [modalOpen, setModalOpen] = useState(true);
  const [organization, setOrganization] = useState();
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [loading, setLoading] = useState(false);
  const [blockRouteChange, setBlockRouteChange] = useState(false);

  const fetchOrganization = async () => {
    const { data } = await getOrganizations(pageNumber, pageSize);

    setOrganization(data);
  };

  useEffect(async () => {
    setLoading(true);

    await fetchOrganization();
    setLoading(false);
  }, [pageNumber, pageSize]);

  const handleModalOpen = ({ id }) => {
    history.push(`/organizations/${id}`);
    setModalOpen(true);
  };

  const handleModalClose = (save) => {
    if (save && typeof save === 'boolean') {
      history.block(() => true);
      setModalOpen(false);
    }

    if (!blockRouteChange && !save && typeof save !== 'boolean') {
      setModalOpen(false);
    }

    history.push('/organizations');
    fetchOrganization();
    window.removeEventListener('beforeunload', refreshReloadPrompt);
  };

  const handleAdd = () => {
    history.push('/organizations/add');
    setModalOpen(true);
    fetchOrganization();
  };

  return (
    <>
      <PageTemplate
        data={get(organization, 'data', [])}
        columns={columns}
        suggestionPrimaryKey={suggestionPrimaryKey}
        suggestionSecondaryKeys={suggestionSecondaryKeys}
        handleModalOpen={handleModalOpen}
        setPageNumber={setPageNumber}
        setPageSize={setPageSize}
        rowCount={get(organization, 'pagination.total', 0)}
        pageNumber={pageNumber}
        pageSize={pageSize}
        loading={loading}
        handleAdd={handleAdd}
        setModalOpen={setModalOpen}
      />

      <Switch>
        <Route path={`${path}/add`}>
          <OrganizationModal
            modalOpen={modalOpen}
            handleModalClose={handleModalClose}
            blockRouteChange={blockRouteChange}
            setBlockRouteChange={setBlockRouteChange}
          />
        </Route>

        <Route path={`${path}/:id`}>
          <OrganizationModal
            modalOpen={modalOpen}
            handleModalClose={handleModalClose}
            blockRouteChange={blockRouteChange}
            setBlockRouteChange={setBlockRouteChange}
          />
        </Route>
      </Switch>
    </>
  );
};
export default Services;
